export type LinkHrefs = {
  first?: string;
  last?: string;
  next?: string;
  prev?: string;
  self?: string;
};

export type LinkMap = {
  readonly [key: string]: { href?: string } | undefined;
};

export const extractLinkHrefs = (links?: LinkMap | null): LinkHrefs => ({
  first: links?.first?.href,
  last: links?.last?.href,
  next: links?.next?.href,
  prev: links?.prev?.href,
  self: links?.self?.href,
});

export const pluralize = (word: string, count: number): string => (count !== 1 ? `${word}s` : word);

/**
 * Check if a string is a valid ObjectId hex representation (24 hex chars)
 * Similar to bson.IsObjectIdHex() - validates length and hex characters explicitly
 */
export function isObjectIdHex(str: string): boolean {
  return /^[a-fA-F0-9]{24}$/.test(str.trim());
}
